export const iconFontAwesomeSpinnersArrowsRotate = (
	<i className="fa-solid fa-arrows-rotate"></i>
);
